
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserDetails {
    id: number;
    uuid: string;
    name: string;
    email: string;
    mobile: string;
    user_type: string;
    reference_user_id: number;
    password: string;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
}

interface UserState {
    user_details: UserDetails | null;
}

const initialState: UserState = {
    user_details: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserDetails: (state, action: PayloadAction<UserDetails>) => {
            state.user_details = action.payload;
        },
        clearUserDetails: (state) => {
            state.user_details = null;
        },
        updateUserDetails: (state, action: PayloadAction<Partial<UserDetails>>) => {
            if (state.user_details) {
                state.user_details = {
                    ...state.user_details,
                    ...action.payload,
                };
            }
        },
    },
});

export const { setUserDetails, clearUserDetails, updateUserDetails } = userSlice.actions;
export default userSlice.reducer;
